import NTPLL_1 from '../assets/projects/NTPLL_UCSD_Bldg_1.jpg';
import NTPLL_2 from '../assets/projects/NTPLL_UCSD_Bldg_2.jpg';
import NTPLL_5 from '../assets/projects/NTPLL_UCSD_Bldg_5.jpg';
import NTPLL_6 from '../assets/projects/NTPLL_UCSD_Bldg_6.jpg';
import LegacyPavilion from '../assets/projects/legacy_international_pavilion_san_diego.jpg';
import LegacyMuseum from '../assets/projects/Legacy_International_Museum_San_Diego.jpg';
import LegacyHotel from '../assets/projects/Legacy_International_Hotel_San_Diego.jpg';
import CheyenneZoo from '../assets/projects/Cheyenne_Mountain_Zoo_Hippo_Primate_Penguin_Exhibit.jpg';
import SerraHS from '../assets/projects/Serra_HS_San_Diego.jpg';

export const PROJECTS = [
    {
        slug: 'ntpll-ucsd-bldg-1',
        title: 'NTPLL at UCSD San Diego — Building 1',
        location: 'San Diego, CA',
        category: 'Education',
        image: NTPLL_1,
    },
    {
        slug: 'ntpll-ucsd-bldg-2',
        title: 'NTPLL at UCSD San Diego — Building 2',
        location: 'San Diego, CA',
        category: 'Education',
        image: NTPLL_2,
    },
    {
        slug: 'ntpll-ucsd-bldg-5',
        title: 'NTPLL at UCSD San Diego — Building 5',
        location: 'San Diego, CA',
        category: 'Education',
        image: NTPLL_5,
    },
    {
        slug: 'ntpll-ucsd-bldg-6',
        title: 'NTPLL at UCSD San Diego — Building 6',
        location: 'San Diego, CA',
        category: 'Education',
        image: NTPLL_6,
    },
    {
        slug: 'legacy-international-pavilion',
        title: 'Legacy International Pavilion',
        location: 'San Diego, CA',
        category: 'Commercial',
        image: LegacyPavilion,
    },
    {
        slug: 'legacy-international-museum',
        title: 'Legacy International Museum',
        location: 'San Diego, CA',
        category: 'Commercial',
        image: LegacyMuseum,
    },
    {
        slug: 'legacy-international-hotel',
        title: 'Legacy International Hotel',
        location: 'San Diego, CA',
        category: 'Commercial',
        image: LegacyHotel,
    },
    {
        slug: 'cheyenne-mountain-zoo',
        title: 'Cheyenne Mountain Zoo — Hippo, Primate & Penguin Exhibit',
        location: 'Colorado Springs, CO',
        category: 'Public Works',
        image: CheyenneZoo,
    },
    {
        slug: 'serra-high-school',
        title: 'Serra High School',
        location: 'San Diego, CA',
        category: 'Education',
        image: SerraHS,
    },
];

export const CATEGORIES = ['All', 'Commercial', 'Education', 'Public Works'];
